import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useReasonsForRefusal = () =>
  useQuery<crmModels.IReasonsRefusal[]>({
    queryKey: [crmConstants.queryKeys.REASONS_FOR_REFUSAL],
    queryFn: async () => {
      const res = await $api.get('/v1/reasons-for-refusal/');

      return res?.data?.data;
    }
  });
